import React from 'react'
import { Link } from 'react-router-dom'
import AdminHeader from './AdminHeader.js'
import useScrollToTop from '../components/useScrollToTop.js';


const AdminEdit = () => {
    useScrollToTop();

    return (
        <div>
            <div>
                <AdminHeader />
                <div className='mx-auto max-w-auto px-6 lg:px-8'>
                    <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6  py-10'>
                        <Link to="/admincomision"> <div className='border border-slate-300 text-sm rounded-lg hover:border-slate-400 cursor-pointer p-4 space-y-3'>
                            <div className='space-y-3'>
                                <p className=' font-semibold'>Edit Comission</p>
                            </div>
                            <p className='border border-gray-300'></p>
                            <p className='text-blue-600'>View Details</p>
                        </div> </Link>

                        <Link to='/admintopbar'> <div className='border border-slate-300 text-sm rounded-lg hover:border-slate-400 cursor-pointer p-4 space-y-3'>
                            <div className='space-y-3'>
                                <p className='font-semibold'>Edit topbar</p>
                            </div>
                            <p className='border border-gray-300'></p>
                            <p className='text-blue-600'>View Details</p>
                        </div></Link>

                        <Link to='/adminpolicy'>   <div className='border border-slate-300 text-sm rounded-lg hover:border-slate-400 cursor-pointer p-4 space-y-3'>
                            <div className='space-y-3'>
                                <p className='font-semibold'>Edit Privacy Policy</p>
                            </div>
                            <p className='border border-gray-300'></p>
                            <p className='text-blue-600'>View Details</p>
                        </div></Link>

                        <Link to='/adminforeignpricelistexcel'>   <div className='border border-slate-300 text-sm rounded-lg hover:border-slate-400 cursor-pointer p-4 space-y-3'>
                            <div className='space-y-3'>
                                <p className='font-semibold'>Upload Foreign Pricelist</p>
                            </div>
                            <p className='border border-gray-300'></p>
                            <p className='text-blue-600'>View Details</p>
                        </div></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminEdit
